import { lazy, Suspense } from 'react';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton } from 'antd';

const LazyBlockDevelopment = lazy(() => import('./BlockDevelopment'));

export const AsyncLazyBlockDevelopment = ({ piletApi }: { piletApi: PiletApi }) => (
	<Suspense fallback={<Skeleton />}>
		<LazyBlockDevelopment piletApi={piletApi} />
	</Suspense>
);
